<template>
    <div>
        <v-view :tableData="tableData"
                :tableProps="tableProps"
                :modalProps="modalProps"
                :columns="columns"
                :routes="routes"
                :buttonsVisibility="buttonsVisibility"
                :initialSort="initialSort"
                :rowButtonAction="rowButtonAction"
                :viewParams="viewParams"
                v-model:selectedRows="selectedRows">

            <template #crud="formProps">
                <OfferProductForm :formProps="formProps">
                </OfferProductForm>
            </template>
            <template #search="searchProps">
                <OfferProductSearch :searchProps="searchProps">
                </OfferProductSearch>
            </template>

            <template #buttons="formProps">
                <div style="margin-left:40px">
                    <FormSelect fieldName="opportunity_id"
                                label=""
                                showClear
                                style="width:600px;padding-top:0"
                                :placeholder="__('Select sell opportunity to filter offer products')"
                                :filtering="true"
                                :change="(e) => filterOffersProductsByOpportunity(e, formProps)"
                                :options="select?.opportunities"
                                v-model:field="opportunityToFilterOffersProducts" />
                </div>
                <div style="margin-left:40px">
                    <CustomButton name="createOrder"
                                  @click.stop="createOrder(formProps)"
                                  :className="buttonClass('green')">
                        <template class="flex items-center gap-1"><i class="fa-solid fa-list-check"></i><span>{{ __('Create order') }}</span></template>
                    </CustomButton>
                </div>
            </template>
        </v-view>

        <Dialog modal
                :visible="isCreateOrderModalOpen"
                v-model:visible="isCreateOrderModalOpen"
                :header="__('Create order')"
                :style="{ width: '800px' }"
                :pt="dialogPt">
            <p style="font-size:16px; font-weight:bold;color:cadetblue">{{ __('Order to supplier will be created for selected products') }}</p>

            <CreateOrderForm :selectedRows="selectedRows"
                             :formProps="formPropsToPass"
                             v-model:isCreateOrderModalOpen="isCreateOrderModalOpen">
            </CreateOrderForm>
        </Dialog>

    </div>
</template>

<script setup>
import { ref, onBeforeMount } from 'vue';
import OfferProductForm from './OfferProductForm.vue'
import OfferProductSearch from './OfferProductSearch.vue'
import FormSelect from '@crud/FormSelect.vue'
import { rowButtonAction } from '@pages/Helper/crud_utils.js'
import CustomButton from '@crud/CustomButton.vue'
import Dialog from 'primevue/dialog';
import CreateOrderForm from './CreateOrderForm.vue'
import { prepareSelect } from '@pages/Helper/crud_utils.js'
import { __, getFromUrl, buttonClass, getFromRoute, screenMessage } from '@pages/Helper/utils.js';


const props = defineProps({
    tableData: Object,
    tableProps: Object,
    modalProps: Object,
    columns: Object,
    routes: Object,
    initialSort: Object,
    buttonsVisibility: Object,
    filters: Object,
    viewParams: Object,
})

const selectedRows = ref([])
const options = ['opportunities']
const select = ref(null)
const isCreateOrderModalOpen = ref(false)
const formPropsToPass = ref(null)
const opportunityToFilterOffersProducts = ref(props.filters?.offers_products_opportunity || null)
const dialogPt = {
    header: { class: 'form-header' },
    content: { class: 'form-body' },
};

//------------------------------------------------------------------------------

onBeforeMount(async () => {
    select.value = await prepareSelect(options)
})

//------------------------------------------------------------------------------

const filterOffersProductsByOpportunity = async (e, formProps) => {
    const opportunity_id = e.value
    await getFromRoute('offerproduct-filter-by-opportunity', { opportunity_id: opportunity_id }, 'get')
    formProps.getLazyData({ page: 1 })
}

//------------------------------------------------------------------------------

function createOrder(formProps) {
    if (!Array.isArray(selectedRows.value) || selectedRows.value.length === 0) {
        const message = {
            message: "No products has been selected",
            title: "Products selection error",
            type: "error",
            position: "center",
            timeout: 5,
        };
        screenMessage(message);
        return false;
    }
    const isNotReadyToOrderOnly = selectedRows.value.find((offer, index, self) => {
        return offer.status_symbol !== 'SYM_READY_TO_ORDER'
    });

    if (isNotReadyToOrderOnly) {
        const message = {
            message: __("Selected offers must have status 'Ready to order'"),
            title: "Offer selection error",
            type: "error",
            position: "center",
            timeout: 5,
        };
        screenMessage(message);
        return false;
    }

    isCreateOrderModalOpen.value = true
    formPropsToPass.value = formProps;
}

//------------------------------------------------------------------------------

</script>

<style lang="scss" scoped></style>
